export default {
  "content": "<path d=\"M22 13.5a6 6 0 01-6 6H7.414l2.793 2.793-1.414 1.414-4.5-4.5a1 1 0 010-1.414l4.5-4.5 1.414 1.414L7.414 17.5H16a4 4 0 004-4V11h2v2.5zM19.707 4.793a1 1 0 010 1.414l-4.5 4.5-1.414-1.414L16.586 6.5H8a4 4 0 00-4 4V13H2v-2.5a6 6 0 016-6h8.586l-2.793-2.793L15.207.293l4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};